import type {GridRowSelectionModel, GridSortModel} from '@mui/x-data-grid'
import {useCallback, useState} from 'react'
import {tablesFullPage} from '@shared/constants/lineManagement'

interface DataGridState {
  sortModel: GridSortModel
  handleSortModelChange: (newSortModel: GridSortModel) => void
  selectedRows: GridRowSelectionModel
  handleModelChange: (newSelection: GridRowSelectionModel) => void
  paginationModel: {page: number; pageSize: number}
  handlePaginationModelChange: (newModel: {pageSize: number; page: number}) => void
}

const useDataGridState = (initialPageSize: number = tablesFullPage.pageSize): DataGridState => {
  // Sorting state
  const [sortModel, setSortModel] = useState<GridSortModel>([])

  // Row selection state
  const [selectedRows, setSelectedRows] = useState<GridRowSelectionModel>({
    type: 'include' as const,
    ids: new Set([]),
  })

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: initialPageSize,
  })

  // Handle sorting change
  const handleSortModelChange = (newSortModel: GridSortModel): void => {
    setSortModel(newSortModel)
  }

  // Handle row selection change
  const handleModelChange = (newSelection: GridRowSelectionModel): void => {
    setSelectedRows(newSelection)
  }

  const handlePaginationModelChange = useCallback((newModel: {pageSize: number; page: number}) => {
    setPaginationModel((prev) => ({
      page: prev.pageSize === newModel.pageSize ? newModel.page : 0, // Reset page on pageSize change
      pageSize: newModel.pageSize,
    }))
  }, [])

  return {
    sortModel,
    handleSortModelChange,
    selectedRows,
    handleModelChange,
    paginationModel,
    handlePaginationModelChange,
  }
}

export default useDataGridState
